import * as React from 'react'

/**
 * @description Edit icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Edit } from '@sravni/design-system-icons'
 *
 * <Edit />
 * ```
 */
export const Edit = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Edit" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.736 2h6a.75.75 0 0 1 0 1.5h-6a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-6a.75.75 0 0 1 1.5 0v6a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.028 2.825a1.964 1.964 0 0 1 2.778 0l.105.105a1.964 1.964 0 0 1 0 2.778l-5.098 5.098a1.362 1.362 0 0 1-.629.355l-2.266.567a.75.75 0 0 1-.91-.91l.567-2.266c.06-.238.183-.457.357-.63l5.096-5.097Zm1.718 1.061a.465.465 0 0 0-.657 0L11.02 8.954l-.254 1.015 1.016-.254 5.067-5.067a.465.465 0 0 0 0-.657l-.104-.105Zm-4.925 5.82Z"
      fill="currentColor"
    />
  </svg>
))
